import React, { createContext, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { AuthenticationContext } from "../AuthenticationProvider/AuthenticationProvider";
import useAPI from "../../hooks/basic/useAPI";

// Create a new context for the authentication provider
export const ClubsContext = createContext({
  coaches: [],
  clubs: [],
  isJanus: false,
});

const ClubsProvider = ({ children }) => {
  const { appUserId } = useContext(AuthenticationContext);
  const [coaches, setCoaches] = useState([]);
  const [isJanus, setIsJanus] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  const { callAPI } = useAPI();

  const fetchCoaches = async () => {
    try {
      const response = await callAPI({
        url: `/coaches-by-athlete`,
        params: {
          athleteId: appUserId,
        },
      });
      setCoaches(response);
      const isJanusCheck = response.some(
        (coach) => coach.groups && coach.groups.includes("janus-tennis-academy"),
      );
      setIsJanus(isJanusCheck);
      console.log("Coaches fetched successfully:", response);
    } catch (error) {
      console.error("Error fetching coaches:", error);
      // Handle error appropriately, e.g., show a toast notification
    } finally {
      setIsInitialized(true);
    }
  };

  useEffect(() => {
    if (appUserId) {
      fetchCoaches();
    }
  }, [appUserId]);

  return (
    <ClubsContext.Provider
      value={{
        clubs: [],
        coaches,
        isJanus,
      }}
    >
      {children}
    </ClubsContext.Provider>
  );
};

ClubsProvider.displayName = "ClubsProvider";

ClubsProvider.propTypes = {
  children: PropTypes.node,
};

export default ClubsProvider;
